var map = {
	"./Union_5.svg": "fc42",
	"./arrow-right-small.svg": "82a2",
	"./arrow-right.svg": "55b9",
	"./arrow_drop.svg": "5b11",
	"./calculator.svg": "89c2",
	"./calendar.svg": "287d",
	"./check.svg": "a7c0",
	"./check_icon_land.svg": "3b31",
	"./check_land_sales.svg": "8084",
	"./click.svg": "4310",
	"./clock.svg": "9f74",
	"./close.svg": "864a",
	"./down-arrow.svg": "127c",
	"./facebook-flat.svg": "76b6",
	"./facebook.svg": "ca4d",
	"./filter.svg": "3663",
	"./grid.svg": "a8cb",
	"./inresize.svg": "cecc",
	"./instagram.svg": "8d62",
	"./left-arrow.svg": "5d26",
	"./link.svg": "5fda",
	"./list.svg": "3561",
	"./loop.svg": "2416",
	"./mail.svg": "8ca3",
	"./manager.svg": "4d7c",
	"./mobile.svg": "a91f",
	"./move-map.svg": "4831",
	"./msg.svg": "abfd",
	"./pdf.svg": "8989",
	"./phone_promo.svg": "5bfc",
	"./pin.svg": "f937",
	"./pin_land.svg": "b59e",
	"./plane.svg": "3740",
	"./play.svg": "4c1a",
	"./precent.svg": "4903",
	"./print.svg": "bdd0",
	"./promo_insta.svg": "0244",
	"./reload.svg": "8561",
	"./resize-gal.svg": "41aa",
	"./resize.svg": "739e",
	"./resize_noll.svg": "e3c2",
	"./right-arrow.svg": "ce12",
	"./star.svg": "4e5a",
	"./telegram-flat.svg": "8f50",
	"./telegram.svg": "fd92",
	"./tenge.svg": "1b81",
	"./unresize.svg": "efcd",
	"./vk-flat.svg": "8646",
	"./vk.svg": "22ec",
	"./warning_online.svg": "ca50",
	"./whatsapp-flat.svg": "6594",
	"./whatsapp.svg": "2201",
	"./whatsapp_flat.svg": "fb6f",
	"./zoom.svg": "d534"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";